import { render, staticRenderFns } from "./PortalTopicAndEventForm.vue?vue&type=template&id=fa9889ba&lang=pug"
import script from "./PortalTopicAndEventForm.vue?vue&type=script&lang=js"
export * from "./PortalTopicAndEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports